import React from "react";
import {Badge, BadgeProps} from "@mui/joy";
import intl from "react-intl-universal";


import {Tooltip} from "../../../../components/Tooltip/Tooltip"


interface NotificationCardBadgeProps extends BadgeProps {
    isRead?: boolean;
}


export const NotificationCardBadge = (
    {
        anchorOrigin = {
            vertical: 'top',
            horizontal: 'right',
        },
        isRead,
    }: NotificationCardBadgeProps) => {
    const defaultSx = {
        '& .MuiBadge-badge': {
            backgroundColor: isRead ? 'var( --select-bg)' : 'var(--lgc-palette-primary-60)',
            top: '8px',
            right: '4px',
            cursor: 'pointer',
        },

        '--Badge-ringColor': isRead ? 'var(--button-icon-btn-color)' : 'var(--lgc-palette-primary-60)',
        '--Badge-ringSize': '1px',
        '--Badge-paddingX': '0',
        '--Badge-minHeight': '6px',
    };

    return (
        <Tooltip title={isRead
            ? intl.get('notification.card.badge.unread').d('Mark as unread')
            : intl.get('notification.card.badge.read').d('Mark as read')}
        >
            <Badge
                anchorOrigin={anchorOrigin}
                sx={defaultSx}
            />
        </Tooltip>
    );
};
